import { render, staticRenderFns } from "./LearningVideoList.vue?vue&type=template&id=c0a50b5c&scoped=true&"
import script from "./LearningVideoList.vue?vue&type=script&lang=js&"
export * from "./LearningVideoList.vue?vue&type=script&lang=js&"
import style0 from "./LearningVideoList.vue?vue&type=style&index=0&id=c0a50b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a50b5c",
  null
  
)

export default component.exports